import { gql } from 'graphql-tag';

export const fullTaskEntryFragment = gql`
  fragment FullTaskEntry on TaskEntry {
    id
    taskUri
    entryDate
    submittedTimestamp
    userUri
    hoursWorked
    hoursRemaining
    estimatedCompletionDate
    quality
    status
    comment
    totalWorkToDate
    user {
      id
      displayText
      loginName
    }
    task {
      id
      displayText
      name
      fullPath {
        id
        displayText
      }
      projectReference {
        id
        displayText
      }
    }
    override {
      id
      userUri
      hoursRemaining
      estimatedCompletionDate
      quality
      comment
      status
      user {
        id
        displayText
        loginName
      }
    }
    lastApprovedEntry {
      id
      hoursRemaining
      estimatedCompletionDate
      hoursWorked
      totalWorkToDate
      override {
        id
        hoursRemaining
        estimatedCompletionDate
      }
    }
  }
`;

export default fullTaskEntryFragment;
